<template>
  <div class="Toolbar">
    <Icon
      :disabled="!snippet"
      icon="copy"
      name="copy"
      morph-to="copy-2"
      hint="copied"
      fill="var(--color-orange)"
      @click="copy"
    />
    <Icon
      :disabled="!snippet"
      icon="tidy"
      name="tidy"
      morph-to="tidy-2"
      hint="tidy!"
      fill="var(--color-green)"
      @click="beautify"
    />
    <Icon
      :disabled="!snippet"
      icon="expand"
      name="expand"
      morph-to="expand-2"
      hint="swishh"
      fill="var(--color-blue)"
      @click="expand"
    />
    <Icon
      :disabled="!snippet"
      icon="bin"
      name="remove"
      morph-to="bin-2"
      hint="removed"
      fill="var(--color-red)"
      @click="remove"
    />
    <Icon
      :disabled="undoCounter <= 0"
      icon="undo"
      name="undo"
      morph-to="undo-2"
      hint="reverted"
      fill="var(--color-purple)"
      @click="undo"
    />
    <!--         <Icon
            @click="showThemes=!showThemes"
            icon="palette"
            name="theme"
            morph-to="palette-2"
            hint="theme"
            fill="var(--color-theme)"
    />-->
    <Icon
      v-if="showThemes"
      icon="color"
      name="purple"
      morph-to="color-2"
      hint="purple"
      fill="var(--color-theme-purple)"
      @click="switchTheme({ name: 'purple', event: $event })"
    />
    <Icon
      v-if="showThemes"
      icon="color"
      name="gray"
      morph-to="color-2"
      hint="gray"
      fill="var(--color-theme-gray)"
      @click="switchTheme({ name: 'gray', event: $event })"
    />
    <!--         <Icon
            @click="switchTheme({name:'white', event: $event})"
            v-if="showThemes"
            icon="color"
            name="white"
            morph-to="color-2"
            hint="white"
            fill="var(--color-theme-white)"
    />-->
    <Icon
      v-if="showThemes"
      icon="color"
      name="darkblue"
      morph-to="color-2"
      hint="darkblue"
      fill="var(--color-theme-darkblue)"
      @click="switchTheme({ name: 'darkblue', event: $event })"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Toolbar',
  components: {},
  props: {
    snippet: Boolean,
  },
  data: () => ({
    showThemes: false,
  }),
  computed: {
    ...mapGetters({
      undoCounter: 'undoCounter',
    }),
  },
  methods: {
    copy() {
      this.$emit('copy');
    },
    remove() {
      this.$emit('remove');
    },
    expand() {
      this.$emit('expand');
    },
    beautify() {
      this.$emit('beautify');
    },
    undo() {
      this.$emit('undo');
    },
    switchTheme({ name, event }) {
      let style = getComputedStyle(document.body);
      let color = style.getPropertyValue(`--color-theme-${name}`);
      let theme = { name, color };
      this.$emit('switchTheme', { theme, event });
    },
  },
};
</script>

<style lang="scss">
.Toolbar {
  position: fixed;
  right: 50px;
  top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
  padding: 25px 15px;
  background-blend-mode: multiply;
  z-index: zIndex(toolbar);
  transition: all 0.5s $ease;

  &::before {
    position: absolute;
    width: 100%;
    height: 100%;
    content: '';
    background-color: var(--color-theme-light);
    opacity: 0.5;
    transition: all 0.2s $ease;
  }

  .Icon {
    cursor: pointer;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
